<template>
    <div>
        <v-radio-group v-model="actionSelect">
            <v-radio :key="1" value="UNSUBALL" color="primary">
                <template v-slot:label>
                    <span v-html="unsubscribe_me_text"></span>
                </template>
            </v-radio>
            <empty-space />
            <v-radio :key="2" value="KEEPALL" color="primary">
                <template v-slot:label>
                    <span v-html="keep_all_text"></span>
                </template>
            </v-radio>
<!--            <v-radio :key="2" value="UNSUBPARTIAL" class="bigLabel" color="primary">-->
<!--                <template v-slot:label>-->
<!--                    <span v-html="keep_subscribe_text"></span>-->
<!--                </template>-->
<!--            </v-radio>-->
        </v-radio-group>
<!--        <div class="cats">-->
<!--            <template v-for="(cat, index) in $store.state.profile.user.enews.cats">-->
<!--                <v-checkbox :disabled="actionSelect!='UNSUBPARTIAL'" v-model="cats[index].selected" :label="cat.text" color="primary"></v-checkbox>-->
<!--            </template>-->
<!--        </div>-->
<!--        <empty-space />-->
        <v-btn depressed large block color="primary_action" @click="saveSettings" :loading="loading">SHRANI spremembe</v-btn>
    </div>
</template>

<script>
    import EmptySpace from "./EmptySpace";
    import utils from "../store/utils";
    import {userService} from "../services";

    export default {
        name: "UnsubscribeSettings",
        components: {EmptySpace},
        props: {
            user_key: {
                type: String,
                default: undefined
            },
            from_link: {
                type: Boolean,
                default: true
            },
            unsubscribe_me_text: {
                type: String,
                default: '<b>DA</b>, odjavi me od prejemanja VSEH elektronskih sporočil.'
            },
            keep_subscribe_text: {
                type: String,
                default: '<b>NE</b>, želim še naprej prejemati občasne e-novice glede na moja zanimanja:'
            },
            keep_all_text: {
                type: String,
                default: '<b>NE</b>, želim še naprej prejemati e-novice.'
            },
        },
        data: vm => ({
            loading: false,
        }),
        computed: {
            cats: utils.vuexBuildSetGet(this, 'profile', 'user.enews.cats'),
            actionSelect: utils.vuexBuildSetGet(this, 'profile', 'user.enews.action'),
        },
        methods: {
            saveSettings(){
                this.loading = true;
                if (this.actionSelect == 'KEEPALL'){
                    if (this.from_link){
                        this.$emit('saved');
                        this.loading = false;
                    } else {
                        userService.saveEnews('subscribe_all', [], this.user_key).then(
                            data => {
                                this.$emit('saved');
                            },
                            error => {
                                this.$emit('error', error);
                            }
                        ).then(() => {
                            this.loading = false;
                        });
                    }
                } else {
                    userService.saveEnews(this.actionSelect, this.$store.state.profile.user.enews.cats, this.user_key).then(
                        data => {
                            this.$emit('saved');
                        },
                        error => {
                            this.$emit('error', error);
                        }
                    ).then(()=>{
                        this.loading = false;
                    });
                }
            },


        }
    }
</script>

<style>

    .bigLabel .v-label {
        display: inline-block !important;
    }

    .cats {
        margin-left: 40px;
    }

    .cats .v-input--selection-controls{
        margin: 0px;
        padding: 0px;
    }

    .cats .v-input__slot {
        margin: 0px !important;
    }

</style>